// @flow

type OptionPropsType = {
  id: string | number,
  name: string
};

type OptionReturnType = {
  value: string | number,
  label: string
};

type OptionsType = Array<{
  filterPosition: number,
  id: string,
  name: string
}>;

export const optionFrom = (item: OptionPropsType, labelNames?: string[]): ?OptionReturnType => {
  if (item) {
    const label = labelNames ? labelNames.map(n => item[n]).join(', ') : item.name;
    return { value: item.id, label };
  }

  return null;
};

export const optionsFrom = (items: Array<OptionPropsType>): Array<?OptionReturnType> => (
  items.map(v => optionFrom(v)).filter(o => o)
);

export const optionsFromWithBlank = (items: Array<OptionPropsType>): any => (
  [{ value: '', label: '...' }, ...optionsFrom(items)]
);

export const optionsFromObject = (items: any): Array<{ value: string | number, label: string }> => Object.keys(items).map(key => ({
  value: key === 'default' ? '' : key,
  label: items[key]
}));

export const toOptions = (data: OptionsType, label?: string[]): Array<{ value: string, label: string }> => (
  data
    .sort((a, b) => (a.filterPosition && a.filterPosition < b.filterPosition) ? -1 : 1)
    .map(r => ({ value: r.id, label: label ? label.map(n => r[n]).join(', ') : r.name }))
);

export const optionById = (options: Array<OptionReturnType>, item: any): Array<OptionReturnType> => (
  options.filter(({ value }) => Number.isInteger(item.id) ? +value === item.id : value === item.id)
);

export const optionsByIds = (options: Array<OptionReturnType>, items: any): Array<OptionReturnType> => (
  items && items.map(({ id }) => options.find(({ value }) => +value === +id))
);
